/**
 * Monthly Coaching is four Live Video Lessons at a discount (the server's
 * rules.ts MEMBERSHIP_DISCOUNT): 20 percent off by default, and a coach
 * may set 0 to 30 percent off.
 */

/** Monthly Coaching's default: four lessons at 20 percent off, to the dollar. */
export function membershipDefaultCents(singleCents: number): number {
  return Math.round((4 * singleCents * 0.8) / 100) * 100;
}

/** "20% off four lessons", from the two real prices; null when there is no discount to say. */
export function discountLine(singleCents: number | null | undefined, membershipCents: number | null | undefined): string | null {
  if (!singleCents || !membershipCents) return null;
  const pct = Math.round((1 - membershipCents / (4 * singleCents)) * 100);
  return pct > 0 ? `${pct}% off four lessons` : null;
}
